import LocalizedString from '@/types/localized-string';

export enum AnnouncementSource {
  CAPINTEL = 'CAPINTEL',
  ENTERPRISE = 'ENTERPRISE',
}

export enum AnnouncementType {
  MATERIAL_CHANGE = 'MATERIAL_CHANGE',
}

export type AnnouncementsAdminState = {
  announcements: Announcement[];
  nextAnnouncementsToken?: string;
  nextParticipantsToken?: string;
  participants: AnnouncementParticipant[];
};

export type UserAnnouncementsState = {
  announcements: UserAnnouncement[];
  nextToken?: string;
  totalCount: number;
  unacknowledgedCount: number;
  unreadCount: number;
  showNotificationCenter: boolean;
};

export type AnnouncementBody = {
  link?: string;
  name?: string;
  symbol?: string;
};

export type UserAnnouncement = {
  _id: string;
  acknowledged: boolean;
  acknowledgmentRequired: boolean;
  body: LocalizedString | Array<AnnouncementBody>;
  createdAt: string;
  createdBy: string;
  createdByFirstName: string;
  createdByLastName: string;
  read: boolean;
  source: AnnouncementSource;
  title: LocalizedString;
  notificationDate?: Date;
  notificationType?: AnnouncementType;
};

export type Announcement = {
  _id: string;
  acknowledgmentCount?: number;
  acknowledgmentRequired: boolean;
  body: LocalizedString;
  createdAt: string;
  createdBy: string;
  createdByFirstName: string;
  createdByLastName: string;
  readCount?: number;
  recipientCount?: number;
  source: AnnouncementSource;
  title: LocalizedString;
  notificationDate?: Date;
  notificationType?: AnnouncementType;
};

export type AnnouncementPayload = {
  acknowledgmentRequired: boolean;
  body: LocalizedString;
  source: AnnouncementSource;
  title: LocalizedString;
};

export type AnnouncementParticipant = {
  _id: string;
  acknowledged: boolean;
  email: string;
  firstName: string;
  lastName: string;
};

export interface MaterialChangeObject {
  [date: string]: UserAnnouncement[];
}
